export default "__VITE_ASSET__BiZrIddb__"